<script>
import RealTimeErrors from "../events/RealTimeErrors.svelte";

/** @type {{ row: any, column: any, api?: any }} */
let { row } = $props();

let errorMsg = $derived(row?.errorMsg || "");
</script>

<div class="error-cell">
	<RealTimeErrors {errorMsg} />
</div>

<style>
.error-cell {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}
</style>
